import cn from 'classnames';
import type { FC } from 'react';
import useIntercomStore from 'store/intercom.store';

const IntercomUnreadCount: FC<{ className?: string }> = ({ className }) => {
  const unreadCount = useIntercomStore(({ unreadCount }) => unreadCount);

  if (!unreadCount || unreadCount < 0) return null;
  return (
    <div
      className={cn(
        'h-5 w-5 bg-red-500 ring-2 ring-white text-white rounded-md text-xs flex justify-center items-center font-bold',
        className,
      )}
    >
      {unreadCount >= 100 ? '99+' : unreadCount}
    </div>
  );
};

export default IntercomUnreadCount;
